import { Button as FBButton } from "flowbite-react";
import tenkenTheme from "../../configs/themes/tenkenTheme";
import LightBulb from "../../assets/icons/light-bulb-icon.png";

const ButtonHelp = (props) => {
  const { onClick, color } = props;
  const buttonColor = color ? color : "default";
  return (
    <FBButton
      color={buttonColor}
      theme={tenkenTheme.button}
      className={"rounded-[6px] lg:h-[40px] h-[38px] " + props.className}
      onClick={onClick}
    >
      <img
        src={LightBulb}
        alt="help"
        className="lg:h-5 lg:w-5 h-[18px] w-[18px] mr-0.5 mb-1"
      />
      <span>{props.children}</span>
    </FBButton>
  );
};

export default ButtonHelp;
